import { useRef, useState } from 'react'
import useSkipFirstRenderEffect from './useSkipFirstRenderEffect'

/** Дебанус, но первый введенный символ не дебаунсится */
const useSkipFirstDebounce = <T extends string | number>(value: T, delay = 300): T => {
  const isFirst = useRef(true)
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useSkipFirstRenderEffect(() => {
    if (isFirst.current) {
      setDebouncedValue(value)
      isFirst.current = false
      return
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value)
      if (!value) {
        isFirst.current = true
      }
    }, delay)
    return () => {
      clearTimeout(handler)
    }
  }, [value])

  return debouncedValue
}

export default useSkipFirstDebounce
